export const NEW_ITEM_VALUE = '';
